import { EntityType, SkogsvardAtgardsGrupp } from "~app/common/models/constants";
import { EntityDTO } from "~app/common/models/entity-models";

export class VKAtgardHelper {

    static isAtgardsGruppSkogsvard(atgardsGrupp: string) {
        return !!SkogsvardAtgardsGrupp.Alla.find(x => x === atgardsGrupp);
    }
    static isAtgardEntitySkogsvard(entity: EntityDTO): boolean {
        return entity.type === EntityType.virkeskopsAtgardSkogsvard;
    }
}
